export default __webpack_public_path__ + "static/media/prodimg-sketch-1.4e7e88d7.png";